export const DMAH_PATHS = {
  APPLICATIONS: '/dmah/applications',
  APPLICATION: '/dmah/application'
} as const
